const initialState = {
    survey: {
        id: 0, 
        surveyNumber: '', 
        proposal: '', 
        salesPerson: '', 
        score: '', 
        comments: '', 
        customer: ''
    },
    percent_complete: 0,
    complete_export: false,
    fetching: false,
    fetched: false,
    error: null,

    detail: {},
    fetchingDetail: false,
    fetchedDetail: false,
    errorDetail: null
}

export function surveyReducer(state = initialState, action) {

    switch (action.type) {

        case "FETCH_SURVEY": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "FETCH_SURVEY_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }

        case "FETCH_SURVEY_FULFILLED": {
            return { ...state, fetching: false, fetched: true, survey: action.payload.data }
        }

        case "SURVEY_ERROR": {
            return { ...state, error: null }
        }

        case "FETCH_SURVEY_DETAIL": {
            return { ...state, fetchingDetail: true, fetchedDetail: false, errorDetail: null }
        }

        case "FETCH_SURVEY_DETAIL_REJECTED": {
            return { ...state, fetchingDetail: false, errorDetail: action.payload }
        }

        case "FETCH_SURVEY_DETAIL_FULFILLED": {
            return { ...state, fetchingDetail: false, fetchedDetail: true, detail: action.payload.data }
        }

        case "SURVEY_DETAIL_ERROR": {
            return { ...state, errorDetail: null }
        }

        case "EXPORT_EXCEL_SURVEY_DETAIL": {
            return { ...state, fetching: false, fetched: true, filter: action.payload.data }
        }
        case "PERCENTAGE_COMPLETE_SURVEY_DETAIL": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "EXPORT_START_SURVEY_DETAIL": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }
        case "FINISH_EXPORT_SURVEY_DETAIL": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "COMPLETE_EXPORT_SURVEY_DETAIL": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }    

        default:
            return state
    }
}